import { useCallback } from "react";
import { useSnackbarMutation } from "../../hooks";
import { BucketAttachment } from "../models";
import { MUTATIONS } from "../mutations";

type CreateServiceReservationReportOpts = Partial<{
  from: Date;
  to: Date;
  serviceId: string;
}>;

export function useServiceReservations(opts: {
  onServiceReservationConfirmed?: () => void;
  onServiceReservationReportCreated?: (attachment: BucketAttachment) => void;
}) {
  const { onServiceReservationConfirmed, onServiceReservationReportCreated } =
    opts;

  const [
    invokeConfirmServiceReservation,
    {
      loading: confirmServiceReservationLoading,
      error: confirmServiceReservationError,
    },
  ] = useSnackbarMutation(MUTATIONS.CONFIRM_SERVICE_RESERVATION, {
    onCompleted: (data) => {
      onServiceReservationConfirmed?.();
    },
  });
  const confirmServiceReservation = useCallback(
    (serviceReservationId: string) => {
      return invokeConfirmServiceReservation({
        variables: {
          serviceReservationId,
        },
      });
    },
    [invokeConfirmServiceReservation]
  );

  const [
    invokeCreateServiceReservationReport,
    {
      loading: createServiceReservationReportLoading,
      error: createServiceReservationReportError,
    },
  ] = useSnackbarMutation(MUTATIONS.CREATE_SERVICE_RESERVATIONS_REPORT, {
    onCompleted: (data) => {
      onServiceReservationReportCreated?.(
        data.createServiceReservationsReport as BucketAttachment
      );
    },
  });

  const createServiceReservationReport = useCallback(
    (filters: CreateServiceReservationReportOpts = {}) => {
      return invokeCreateServiceReservationReport({
        variables: filters,
      });
    },
    [invokeCreateServiceReservationReport]
  );

  return {
    confirmServiceReservation,
    confirmServiceReservationLoading,
    confirmServiceReservationError,
    createServiceReservationReport,
    createServiceReservationReportLoading,
    createServiceReservationReportError,
  };
}
